import {GenericRequest, getUrlEndpointPrivate} from '@cuatroochenta/co-admin-react-library';
import {SummaryListExportExcelRequest} from '../request/SummaryListExportExcelRequest';

export default class TaskSummaryListExportExcel extends GenericRequest {

    private readonly data;

    public constructor(data: SummaryListExportExcelRequest) {
        super('POST' as any, getUrlEndpointPrivate('summary/export'));
        this.data = data;
    }

    public overrideRequest() {
        return this.data;
    }
}
